// Owner: views-layouts (wave 2); conversion by ui-layers. Below 640 px the list route of every object
// (`/o/<key>`) is covered by the generic phone list (plan §9.23, §3.11): the saved view as cards,
// board columns, agenda or grouped timeline. Not a layer: an always-mounted light effect that loads
// the phone list only on phones.
import { useQuery } from '@tanstack/react-query';
import { useRouterState } from '@tanstack/react-router';
import { Suspense, lazy } from 'react';
import { useIsCompact } from '@dataroom/ui';
import { modelQuery } from '../lib/queries';
import { defineOverlayEffect } from '../shell/overlays';

const PhoneList = lazy(() =>
  import('../features/views/mobile-list/MobileList').then((m) => ({ default: m.MobileList })),
);

const LIST_PATH = /^\/o\/([a-z][a-z0-9_]*)\/?$/;

function MobileListEffect() {
  const mobile = useIsCompact();
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const key = mobile ? LIST_PATH.exec(pathname)?.[1] : undefined;
  const model = useQuery({ ...modelQuery, enabled: Boolean(key) }).data;
  const object = key ? model?.objectByKey(key) : undefined;
  if (!object) return null;
  return (
    <div className="ml-overlay" data-testid="screen-mobile-list">
      <Suspense fallback={null}>
        <PhoneList object={object} />
      </Suspense>
    </div>
  );
}

export default defineOverlayEffect(MobileListEffect);
